import * as React from 'react';

const baseUrl = 'https://support.mri-inc.net';
const baseTicketsUrl = `${baseUrl}/agent/tickets`;

export interface IZendeskLinkProps {
    readonly className?: string;
    readonly children: React.ReactNode;
    readonly id: string;
}
export const ZendeskLink = ({ className, children, id }: IZendeskLinkProps) => {
    const url = `${baseTicketsUrl}/${id}`;

    return (
        <a className={className} href={url} target="_blank">
            {children}
        </a>
    );
};
